module.exports = __webpack_public_path__ + "media/images/menu_l-1949e75aa9bd06a050722ae157a1d84e.gif";